import { Pipe, PipeTransform, inject } from '@angular/core';
import { _ } from '@ngx-translate/core';
import { TranslateService } from '@ngx-translate/core';

const INVITE_STATUS = {
  0: _('common.constants.inviteStatus.notReady'), // 0 - Ожидание
  1: _('common.constants.inviteStatus.ready'), // 1 - Отправлено
  2: _('common.constants.inviteStatus.accepted'), // 2 - Принято
  3: _('common.constants.inviteStatus.rejected'), // 3 - Отклонено
};

@Pipe({
  name: 'inviteStatus',
})
export class InviteStatusPipe implements PipeTransform {
  private readonly translateService = inject(TranslateService);

  transform(value?: number): string {
    switch (value) {
      case 0:
      case 1:
      case 2:
      case 3:
        return this.translateService.instant(INVITE_STATUS[value]);

      default:
        return this.translateService.instant('common.labels.unknownStatus');
    }
  }
}
